import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { makeStyles } from "tss-react/mui";
import * as Icons from "react-feather";
import { RouterLinkWrapper } from "component/shared/router-link-wrapper";
import { styles, pageHeaderLinkStyle } from "./style";

interface OwnProps {
	title: string;
	description?: string | React.ReactNode;
	// Optional right-aligned action, rendered on the same line as the title (e.g. a "View Search" link).
	action?: React.ReactNode;
}

interface Props extends OwnProps, WithStyles<typeof styles> {}

const Component: React.FC<Props> = ({ classes = {}, title, description, action }) => (
	<Mui.Box className={classes.root}>
		<Mui.Box className={classes.titleRow}>
			<Mui.Typography variant="h1" className={classes.title}>{title}</Mui.Typography>
			{action && <Mui.Box className={classes.action}>{action}</Mui.Box>}
		</Mui.Box>
		{description && (
			<Mui.Box className={classes.descriptionRow}>
				<Mui.Typography variant="body2" className={classes.description}>{description}</Mui.Typography>
			</Mui.Box>
		)}
	</Mui.Box>
);

export const PageHeader = withStyles(Component, styles);

const useLinkStyles = makeStyles()((theme) => ({
	link: pageHeaderLinkStyle(theme),
}));

interface PageHeaderLinkProps {
	/** External page, opened in a new tab. */
	href?: string;
	/** In-app route. */
	to?: string;
	children: React.ReactNode;
}

/** The "View {Page}" link for page headers that are not built with PageHeader. */
export const PageHeaderLink: React.FC<PageHeaderLinkProps> = ({ href, to, children }) => {
	const { classes } = useLinkStyles();
	const content = (
		<>
			{children}
			<Icons.ExternalLink size={14} />
		</>
	);
	if (to) {
		return (
			<Mui.Link component={RouterLinkWrapper} to={to} className={classes.link}>
				{content}
			</Mui.Link>
		);
	}
	return (
		<Mui.Link href={href} target="_blank" rel="noopener noreferrer" className={classes.link}>
			{content}
		</Mui.Link>
	);
};
